/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Windows_3Inputs */

const en_pc_dl_windows_3 = /** @type {(inputs: Pc_Dl_Windows_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start PdfCraft from the Start menu. The installer also adds “Edit with PdfCraft” to the right-click menu of PDF files and “Create PDF with PdfCraft…” to the right-click menu of images (on Windows 11, under “Show more options”).`)
};

const zh_pc_dl_windows_3 = /** @type {(inputs: Pc_Dl_Windows_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从开始菜单启动 PdfCraft。安装程序还会在 PDF 文件的右键菜单中加入「Edit with PdfCraft」，在图片的右键菜单中加入「Create PDF with PdfCraft…」（Windows 11 中位于「显示更多选项」里）。`)
};

/**
* | output |
* | --- |
* | "Start PdfCraft from the Start menu. The installer also adds “Edit with PdfCraft” to the right-click menu of PDF files and “Create PDF with PdfCraft…” to the ..." |
*
* @param {Pc_Dl_Windows_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_windows_3 = /** @type {((inputs?: Pc_Dl_Windows_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Windows_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_windows_3(inputs)
	return zh_pc_dl_windows_3(inputs)
});
export { pc_dl_windows_3 as "pc.dl.windows.3" }